module.exports = __webpack_public_path__ + "static/storyboard1-b4eb4f1abd0da4f0e6a031eefa7523e6.gif";